
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consign",
      function () {
        return require("private-next-pages/consign.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/consign"])
      });
    }
  